import { ILicenseModel, LicenseModel } from "@common/models";
import { ILicenseRequestModel } from "@common/models/requests";
import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";

export class LicenseService {

    private static baseUrl: string = '/api/license';

    public static tags = {
        addLicense: "addLicense",
        updateLicense: "updateLicense",
        deleteLicense: "deleteLicense"
    }

    static addLicense = (request: ILicenseRequestModel): Promise<LicenseModel> =>
        trackPromise(new Promise<LicenseModel>((resolve, reject) => {
            http(`${this.baseUrl}`)
                .post<ILicenseModel>(request)
                .then(json => resolve(new LicenseModel(json)))
                .catch(reject)
        }), this.tags.addLicense);

    static updateLicense = (licenseId: number, updateRequest: Partial<ILicenseRequestModel>): Promise<LicenseModel> =>
        trackPromise(new Promise<LicenseModel>((resolve, reject) => {
            http(`${this.baseUrl}/${licenseId}`)
                .put<ILicenseModel>(updateRequest)
                .then(json => resolve(new LicenseModel(json)))
                .catch(reject)
        }), this.tags.updateLicense);

    static deleteLicense = (licenseId: number): Promise<boolean> =>
        trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/${licenseId}`)
                .delete()
                .then(resolve)
                .catch(reject)
        }), this.tags.deleteLicense);
}
